<!--Author: Ashish Kumar -- Founder@InnovNet-->
<div
  class="app-chrome-cluster"
  *ngIf="shouldShowAppShell()"
  [class.is-collapsed]="!isSidebarVisible">
  <a
    *ngIf="!isSidebarVisible"
    class="app-collapsed-logo"
    routerLink="/home"
    aria-label="Innovnet home">
    <img src="/innovnet_icon.png" alt="Innovnet" class="innovnet-icon" />
    <span class="app-collapsed-wordmark">Innovnet</span>
  </a>
  <ui-theme-control *ngIf="shouldShowAppShell() && !isSidebarVisible && isAdmin" [iconOnly]="true"></ui-theme-control>
  <button
    type="button"
    class="app-sidebar-toggle"
    (click)="toggleSidebar()"
    [attr.aria-expanded]="isSidebarVisible"
    aria-controls="appSidebar"
    [attr.aria-label]="sidebarToggleLabel"
    [attr.title]="sidebarToggleLabel">
    <app-menu-toggle-icon [open]="isSidebarVisible" [duration]="500"></app-menu-toggle-icon>
  </button>
</div>

<div
  class="app-sidebar-backdrop"
  *ngIf="shouldShowAppShell() && sidebarOpen"
  (click)="closeSidebar()"></div>

<app-sidebar
  *ngIf="shouldShowAppShell()"
  [open]="sidebarOpen"
  [collapsed]="sidebarCollapsed"
  (openChange)="sidebarOpen = $event"
  (collapsedChange)="setSidebarCollapsed($event)"
  (navigate)="closeSidebar()">
</app-sidebar>

<main
  class="app-main"
  [class.app-main-with-sidebar]="shouldShowAppShell()"
  [class.app-main-sidebar-collapsed]="shouldShowAppShell() && sidebarCollapsed"
  [class.has-trial-banner]="!!trialBanner">
  <div class="trial-banner" *ngIf="shouldShowAppShell() && trialBanner">
    <span *ngIf="!trialBanner.ended">Pro trial: {{ trialBanner.daysLeft }} day{{ trialBanner.daysLeft === 1 ? '' : 's' }} left<span *ngIf="trialBanner.endsOn"> (ends {{ trialBanner.endsOn }})</span>.</span>
    <span *ngIf="trialBanner.ended">Your Pro trial has ended.</span>
    <a routerLink="/settings">{{ trialBanner.ended ? 'Upgrade' : 'Keep Pro' }}</a>
  </div>
  <router-outlet></router-outlet>
</main>

<!-- Scroll to Top Button -->
<button
  class="scroll-to-top-btn"
  *ngIf="shouldShowScrollToTop()"
  (click)="scrollToTop()"
  title="Scroll to top">
  <i class="fas fa-chevron-up"></i>
</button>

<app-error-modal></app-error-modal>
<app-modal></app-modal>
<app-ai-assistant-modal></app-ai-assistant-modal>
<app-command-palette *ngIf="!isAdminRoute()"></app-command-palette>
<app-upgrade-prompt></app-upgrade-prompt>
